import React from "react";
import "./ServerErrorOverlay.css";
import { WifiOff } from "lucide-react";

const ServerErrorOverlay = () => {
  return (
    <div className="ServerErrorOverlay">
      <div className="ServerErrorOverlay--Content">
        <WifiOff size={64} />
        <h1 className="ServerErrorOverlay--Title">
          Не удалось подключиться к серверу
        </h1>
        <p className="ServerErrorOverlay--Message">
          Похоже, у нас возникли технические проблемы. Мы уже работаем над их
          устранением.
        </p>
        <p className="ServerErrorOverlay--Contact">
          Если проблема не исчезнет, пожалуйста, свяжитесь с администратором.
        </p>
      </div>
    </div>
  );
};

export default ServerErrorOverlay;
